import { type JSX, useEffect, useState } from "react";
import { MembershipCancelDuesModal } from "pages/MembershipCancelDuesModal";
import { MembershipPageLayout } from "pages/MembershipPageLayout";
import { useDashboardViewModel } from "pages/dashboard/utils";
import * as API from "lib/api/types";
import { useAppContext } from "utils/hooks";
import { assertPresent } from "utils/types";

const MembershipPage = (): JSX.Element => {
  const { api, currentUser } = useAppContext();
  const [showCancelDuesModal, setShowCancelDuesModal] = useState(false);

  assertPresent(currentUser);
  const viewModel = useDashboardViewModel(currentUser.profile);
  const [paymentHistory, setPaymentHistory] = useState<API.PaymentHistoryItem[]>([]);

  useEffect(() => {
    let active = true;

    const loadPaymentHistory = async (): Promise<void> => {
      const [err, result] = await api.getPaymentHistory();
      if (!active) return;

      if (err || !result) {
        // Payment history is non-critical; fall back to the empty state rather
        // than blocking the page on a failed fetch.
        console.error(err ?? new Error("Payment history was empty"));
        return;
      }

      setPaymentHistory(result.payments);
    };

    void loadPaymentHistory();

    return () => {
      active = false;
    };
  }, [api]);

  return (
    <>
      <MembershipPageLayout
        onCancelDues={() => setShowCancelDuesModal(true)}
        paymentHistory={paymentHistory}
        viewModel={viewModel}
      />
      {showCancelDuesModal ? (
        <MembershipCancelDuesModal
          allowWaiver={viewModel.memberStatus !== API.MemberStatus.DECEASED}
          onClose={() => setShowCancelDuesModal(false)}
        />
      ) : null}
    </>
  );
};

export default MembershipPage;
